<div class="overlay">
  <app-loader></app-loader>
</div>
